module.exports = __webpack_public_path__ + "static/media/contact-page-phone.a5fe016b.svg";